module.exports = __webpack_public_path__ + "media/images/instructions/1-eb108273969146134f287b0cef043596.png";